// extracted by mini-css-extract-plugin
export var container = "_5b-0";
export var fallback = "_5b-5";
export var fallbackIcon = "_5b-6";
export var hidden = "_5b-2";
export var image = "_5b-3";
export var loaded = "_5b-4";
export var placeholder = "_5b-1";